import PropTypes from 'prop-types';
import React from "react";
import { Link } from 'react-router-dom';
import buildUrl from "build-url-ts";
import cx from 'classnames';
import { Row, Col } from 'react-bootstrap';

import { ToolBar, ToolBarGroup } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
// import BackButton from 'src/components/BackButton';

import Button from 'src/components/button';

import AssetSearchResultContainer from './asset/AssetSearchResultContainer.jsx';
import SearchResultView from '../search/SearchResultView.jsx';
import CustomFieldSearchViewContainer from "../search/customField/CustomFieldSearchViewContainer";
import styles from './style.module.scss';

import ActionBar from 'src/components/actionbar';

import EmptyMessageContainer from "../search/emptyMessage/EmptyMessageContainer";
import SearchContainer from '../search/searchContainer/index.jsx';
import _ from 'lodash';

import { localizedStrings } from 'src/localization';

class SearchView extends React.Component {
  static childContextTypes = {
    recordAssetClicked: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      query: '',
      isSearch: false,
      filter: 'all',
      fields: []
    }

    this.primaryBackground = null;
    this._onQueryChange = this._onQueryChange.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this.handleViewMoreClick = this.handleViewMoreClick.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this._handleFieldsFilterChange = this._handleFieldsFilterChange.bind(this);
    this.recordAssetClicked = this.recordAssetClicked.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSearch = localizedStrings.pages.search;
    this.localizedKeywords = localizedStrings.keywords;

  }

  getChildContext() {
    return {
      recordAssetClicked: this.recordAssetClicked
    }
  }

  onFilterChange(filter) {
    this.setState({
      filter: filter
    });
    this.handleViewMoreClick(filter)
  }

  _onQueryChange(e) {
    this.setState({
      query: e.target.value
    });
  }

  _handleFieldsFilterChange(fields) {
    var streamId = this.props.params.id;
    var url = `/streams/${streamId}/search/assets`;

    var query = this.state.query;
    var queryParams = {};

    if (query != "" && typeof query !== "undefined") {
      queryParams["query"] = query;
    }

    var fieldQuery = this.convertFieldsFilterToQueryParams(fields);
    if (fieldQuery) {
      queryParams["fields"] = fieldQuery;
    }

    url = buildUrl(url, {
      queryParams: queryParams
    });

    this.props.navigate(url);
  }

  convertFieldsFilterToQueryParams(fields) {
    if (!fields || fields.length == 0) {
      return null;
    }

    var query = fields.map(field => {
      var optionsQuery = field.options.map(o => {
        return o.index;
      }).join("|");

      return field.index + "|" + optionsQuery;
    }).join(",");

    return query;
  }

  _handleSearch(e) {
    if (e) {
      e.preventDefault();
    }

    var query = this.state.query;
    var streamId = this.props.params.id;
    var filterName = _.get(this.state, 'filter');
    var filterType = filterName === "all" ? "Everything" : _.capitalize(filterName);
    var url = `/streams/${streamId}/search`;

    if (query != '' && typeof query !== 'undefined') {
      url = `${url}?query=${query}`;
    }

    this.props.navigate(url, { replace: true });


    this.invalidateSearch();

    if (query == '' || typeof query === 'undefined') {
      return;
    }
    this.props.trackAdoptionMetricsForContentSearchEvent("Stream", query, filterType, [], {});
    var filter = {
      streams: streamId
    }

    this.props.searchGroups(this.state.query, filter, 0, 12, true);
    this.props.searchAsset(this.state.query, filter, 0, 12, true, false);
    this.props.fetchTags(this.state.query, filter);

    this.props.recordSearchQuery({
      query: this.state.query
    });
  }

  invalidateSearch() {
    this.props.invalidateAssetSearchResult();
    this.props.invalidateGroupsSearchResult();
    this.props.invalidateTags()
  }

  handleViewMoreClick(field) {

    var streamId = this.props.params.id;

    var url = `/streams/${streamId}/search/${field}`;

    if (this.state.query != '' && typeof this.state.query !== 'undefined') {
      url = `${url}?query=${this.state.query}`;
    }

    this.props.navigate(url, { replace: true });
  }

  recordAssetClicked(asset) {
    this.props.recordSearchQuery({
      query: this.state.query,
      asset: asset
    });
  }

  componentDidMount() {
    this.primaryBackground = _.get(this.props.account, 'theme.primaryPalette.backgroundColor');
    this.props.fetchCustomFields();
    if (!this.props.stream) {
      this.props.fetchStream(this.props.params.id)
    }

    if (this.props.location.query) {
      this.setState({
        query: _.get(this.props, "location.query.query"),
        tags: _.get(this.props, "location.query.tags")
      }, () => {
        this._handleSearch();
      });
    } else {
      this.invalidateSearch();
    }
  }

  componentWillUnmount() {
    this.invalidateSearch();
  }

  handleClearQuery(e) {
    e.preventDefault()
    this.setState({
      query: ""
    })
  }

  clearValue(){
    this.setState({
      query: ""
    })
    this.invalidateSearch()
  }

  render() {
    const seekEnabled = _.get(this.props, "account.seekEnabled");
    return (
      <div className={styles.content}>
        <Col
          sm={12}
          className={{
            [styles.searchContainer]:
              (this.props.customFields && _.size(_.get(this.props, "customFields")) > 0)
          }}
        >
          <Row className={styles.top}>
            <Col sm={8} className={cx(styles.column, styles.noPadding)}>

              <div onClick={() => {
                this.invalidateSearch();
                this.props.invalidateSeekSession();
                this.props.navigate(`/streams/${this.props.params.id}`, { replace: true });
              }} className={styles.backContainer}>
                <i className="paperflite-arrow-up"></i>
                <span className={styles.title}>{ _.get(this.props, "stream.name","")}</span>
              </div>

              <div className={styles.titleContainer}>
                <div className={styles.title}>
                  <h1 className={styles.pageTitle}>{this.localizedSearch.title}</h1>
                  {!seekEnabled && <p className={styles.subTitle}>{this.localizedSearch.sub_text}</p>}
                  {seekEnabled && <p className={styles.seekSearch}> { this.localizedSearch.seek_enabled.sub_text} <span className={styles.seekText}> { this.localizedKeywords.seek } </span></p>}
                </div>
              </div>
            </Col>

            <SearchContainer
              isFromStream={true} 
              location={this.props.location} 
              stream={this.props.stream} 
              query={this.state.query} 
              _handleSearch={this._handleSearch}
              clearValue={this.clearValue.bind(this)}
              _onQueryChange={this._onQueryChange.bind(this)} 
              isFetching={() => this.validateLoadingMessage()} 
            />

          </Row>

          {this._renderFilterGroup()}

          {this.validateLoadingMessage() && this._renderLoadingMessage()}

          {_.size(_.get(this.props, "assets.items")) > 0 &&
            <Row className={styles.container}>
              <Col sm={12} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.section}>
                  <label className={cx(styles.item, styles.text)}> {`${this.localizedKeywords.assets} (${this.props.assets.totalRecordsCount})`} </label>
                </div>
              </Col>
              {this.renderTagView()}
              <AssetSearchResultContainer items={this.props.assets.items} />
              {this.renderPagination("assets", this.props.assets)}
            </Row>
          }
          {_.size(_.get(this.props, "groups.items")) > 0 &&
            <Row className={styles.container}>
              <Col sm={12} className={cx(styles.column, styles.noPadding)}>
                <div className={styles.section}>
                  <label className={cx(styles.item, styles.text)}>{`${this.localizedKeywords.groups} (${this.props.groups.totalRecordsCount})`} </label>
                </div>
              </Col>
              <SearchResultView items={this.props.groups.items} />
              {this.renderPagination("groups", this.props.groups)}
            </Row>
          }
          {this.validateEmptyMessage() && !this.validateLoadingMessage() &&
            this.renderEmptyMessage()
          }
          {this.props.customFields && _.size(_.get(this.props, "customFields")) > 0 && (
            <Col sm={2}>
              <CustomFieldSearchViewContainer fields={this.props.customFields} value={[]} onChange={this._handleFieldsFilterChange} />
            </Col>
          )}
        </Col>
      </div>
    );
  }

  validateLoadingMessage() {
    if (this.props.assetsSearching) {
      return true;
    } else if (this.props.groupsSearching) {
      return true;
    } else if (this.props.streamsSearching) {
      return true;
    }
    return false;
  }

  validateEmptyMessage() {
    if (_.size(_.get(this.props, "assets.items")) == 0 && _.size(_.get(this.props, "groups.items")) == 0 &&
      _.size(_.get(this.props, "streams.items")) == 0) {
      return true;
    }

    return false;
  }

  _renderLoadingMessage() {
    return (
      <div className={styles.loadingMessage}>{this.localizedCommons.actions.searching}...</div>
    );
  }

  renderEmptyMessage() {
    if (!_.get(this.props, "assets.query")) {
      return (
        <div className={styles.empty}>
          <span className={styles.emptyMessageImage}></span>
          <h3>{this.localizedSearch.empty_message.title}</h3>
          <p>{this.localizedSearch.empty_message.sub_text}</p>
        </div>
      )
    }

    return (
      <EmptyMessageContainer searchQuery={_.get(this.props, "assets.query")}></EmptyMessageContainer>
    )
  }

  _renderFilterGroup() {
    return (
      <ToolBar className={styles.toolbar}>
        <ToolBarGroup item={styles.item}>
          <ToolBarButtonItem className={cx(styles.filterHeading)} width="auto" height="auto">
            <div> {this.localizedSearch.filters.title}: </div>
          </ToolBarButtonItem>
          <ToolBarButtonItem className={cx(styles.filter)} width="auto" height="auto">
            <div className={cx(styles.link, { [styles.active]: this.state.filter == 'all' })} >
              {this.localizedSearch.filters.everything}
            </div>
          </ToolBarButtonItem>
          <ToolBarButtonItem className={cx(styles.filter)} width="auto" height="auto">
            <div className={cx(styles.link, { [styles.active]: this.state.filter == 'assets' })}
              onClick={this.onFilterChange.bind(this, 'assets')}>
              {this.localizedKeywords.assets}
            </div>
          </ToolBarButtonItem>

          <ToolBarButtonItem className={cx(styles.filter)} width="auto" height="auto">
            <div className={cx(styles.link, { [styles.active]: this.state.filter == 'groups' })}
              onClick={this.onFilterChange.bind(this, 'groups')}>
              {this.localizedKeywords.groups}
            </div>
          </ToolBarButtonItem>
        </ToolBarGroup>
      </ToolBar>
    );
  }

  renderTagView() {
    if (!(this.props.tags && this.props.tags.length > 0)) {
      return false;
    }

    return (
      <Col md={12}>
        <div className={styles.tagView}>
          <Link key={'all'} className={cx(styles.tag, { [styles.active]: !_.get(this.props, "location.query.tags") })} to={`/streams/${this.props.params.id}/search/assets?query=${this.state.query}`}>
            #{this.localizedSearch.asset.all_tags} ({this.props.totalItems}),
          </Link>
          {this.renderTags()}
        </div>
      </Col>
    );
  }

  renderTags() {
    return _.get(this.props, "tags", []).map((tag, index) => {
      return (
        <Link key={index} className={styles.tag} to={`/streams/${this.props.params.id}/search/assets?query=${this.state.query}&tags=${tag.key}`}>
          #{tag.key} ({tag.count}),
        </Link>
      );
    })
  }
  renderPagination(entityType, pagination) {
    var remainingItems = pagination.totalRecordsCount - pagination.recordsPerPage;
    if (remainingItems <= 0) {
      return false;
    }

    return (
      <div className={styles.pagination}>
        <div
          className={cx(styles.item, styles.text, styles.action)}
          onClick={() => this.handleViewMoreClick(entityType)}
        >
          <i className="paperflite-plus"></i> <span className={styles.upperCase}>{`${this.localizedCommons.actions.view_more}(${remainingItems})`}</span>
        </div>
      </div>
    );
  }
}

export default SearchView;